var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilletera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.71 90.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "billetera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5,14.13H54.16a11,11,0,0,1-8.59-4L41.17,4a10.74,10.74,0,0,0-8.55-4H23.19C6.25,0,0,9.94,0,26.84V45.11c0,2,90.69,2,90.69,0V39.8C90.77,22.9,84.68,14.13,67.5,14.13Z",
    fill: "#85bd3d",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.46,14.13a23.66,23.66,0,0,1,16.46,5,13.1,13.1,0,0,1,1.49,1.49,17.94,17.94,0,0,1,3.31,5.75,38.82,38.82,0,0,1,2,13.44V63.63a41.42,41.42,0,0,1-.44,6,27.19,27.19,0,0,1-3.63,9.9,20.07,20.07,0,0,1-3.07,4,27.24,27.24,0,0,1-19.8,7.12H26.9A27.33,27.33,0,0,1,7.06,83.55a20.16,20.16,0,0,1-3-4,26.51,26.51,0,0,1-3.55-9.9,37.61,37.61,0,0,1-.48-6V39.8a56.19,56.19,0,0,1,.32-5.95,22.38,22.38,0,0,0,.41-2.7,25.61,25.61,0,0,1,2.21-6.88c3.15-6.72,9.6-10.14,20.17-10.14Zm1.09,39.8h-46a3.74,3.74,0,1,0,0,7.48H68.27a3.74,3.74,0,0,0,3.91-3.62,3.35,3.35,0,0,0-.8-2.41A3.55,3.55,0,0,0,68.55,53.93Z",
    fill: "#85bd3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilletera);
export default __webpack_public_path__ + "static/media/billetera.ad941070.svg";
export { ForwardRef as ReactComponent };